export function joinAllFields(adminFields, enduserFields) {
  let joinedFields = [];

  joinedFields = enduserFields.filter(
    field => field.uiType === 'section_break'
  );

  joinedFields = joinedFields.concat(adminFields);

  joinedFields.sort((a, b) => {
    return a.position - b.position;
  });

  return joinedFields;
}

export function initializeSections(allFields) {
  //when the key = "" it means the admin fields have no section header
  const sectionsMap = {};
  let fieldsInSection = [];
  let sectionBreakId = '';

  allFields.forEach(field => {
    if (field.uiType === 'section_break') {
      if (fieldsInSection.length) {
        sectionsMap[sectionBreakId] = fieldsInSection;
        fieldsInSection = [];
      }
      sectionBreakId = field.internalId;
    } else {
      fieldsInSection.push(field.internalId);
    }
  });

  if (fieldsInSection.length !== 0) {
    sectionsMap[sectionBreakId] = fieldsInSection;
  }

  return sectionsMap;
}

export function existsInMap(id, sectionsMap) {
  if (Object.keys(sectionsMap).includes(id)) {
    return true;
  } else {
    for (let i = 0; i < Object.values(sectionsMap).length; i++) {
      if (Object.values(sectionsMap)[i].includes(id)) {
        return true;
      }
    }
  }
  return false;
}

export function formatGroupIds(groupIds) {
  if (groupIds) {
    if (groupIds.length === 1 && groupIds.includes('')) {
      return [];
    }
  }
  return groupIds;
}

// export default {
//   joinAllFields,
//   initializeSections,
//   existsInMap,
//   formatGroupIds
// };
// export default existsInMap;
// export default formatGroupIds;
